module.exports = __webpack_public_path__ + "components/flag/static/square/et-1d7878cf1530de165d1275d0f23b86ef.svg";